export default __webpack_public_path__ + "static/media/avatar-s-10.a65df8f6.jpg";